import { ButtonTypes } from '../enums/button-types.enum';
import { ButtonType } from '../interfaces/button-type.interface';

export const BUTTON_TYPES: ButtonType[] = [
  {
    value: ButtonTypes.None,
    title: 'Not Assigned',
    parameter: false,
  },
  // {
  //   value: 'local',
  //   title: 'Configure on phone',
  //   parameter: false,
  // },
  {
    value: ButtonTypes.Private,
    title: 'Private line',
    parameter: false,
  },
  {
    value: ButtonTypes.Extension,
    title: 'Extension BLF',
    parameter: true,
  },
  {
    value: ButtonTypes.Park,
    title: 'Park Orbit',
    parameter: true,
  },
  {
    value: ButtonTypes.Login,
    title: 'Agent login/logout',
    parameter: true,
  },
  {
    value: ButtonTypes.Flag,
    title: 'Service Flag',
    parameter: true,
  },
  {
    value: ButtonTypes.Speed,
    title: 'Speed Dial',
    parameter: true,
  },

  //last 2 not sure
  {
    value: ButtonTypes.HuntGroup,
    title: 'Hunt group',
    parameter: true,
  },
  {
    value: ButtonTypes.AgentGroup,
    title: 'Agent group',
    parameter: true,
  },

  // {
  //   value: 'attendant',
  //   title: 'Auto Attendant',
  //   parameter: true,
  // },
  // {
  //   value: 'hunt',
  //   title: 'Ring Group',
  //   parameter: true,
  // },
  // {
  //   value: 'queue',
  //   title: 'Call Queue',
  //   parameter: true,
  // },

  // {
  //   value: 'conference',
  //   title: 'Conference',
  //   parameter: true,
  // },

  // {
  //   value: 'ivrnode',
  //   title: 'IVR Node',
  //   parameter: true,
  // },
  // {
  //   value: 'coline',
  //   title: 'CO-Line',
  //   parameter: true,
  // },
  // {
  //   value: 'page',
  //   title: 'Paging',
  //   parameter: true,
  // },

  // {
  //   value: 'intercom',
  //   title: 'Intercom',
  //   parameter: true,
  // },
  // {
  //   value: 'vm',
  //   title: 'Voicemail',
  //   parameter: true,
  // },
  // {
  //   value: 'dnd',
  //   title: 'Do not disturb (DND)',
  //   parameter: false,
  // },

  // {
  //   value: 'redirect',
  //   title: 'Redirect',
  //   parameter: true,
  // },
  // {
  //   value: 'group',
  //   title: 'Pickup group',
  //   parameter: false,
  // },
  // {
  //   value: 'cell',
  //   title: 'Cell Phone',
  //   parameter: false,
  // },

  // NOTE: seems from there not visible for Polycom

  // {
  //   value: 'url',
  //   title: 'URL',
  //   parameter: true,
  //   notVisibleFor: ['Polycom'],
  // },
  // {
  //   value: 'record',
  //   title: 'Record',
  //   parameter: false,
  //   notVisibleFor: ['Polycom'],
  // },
  // {
  //   value: 'prefix',
  //   title: 'Prefix',
  //   parameter: true,
  //   notVisibleFor: ['Polycom'],
  // },
  // {
  //   value: 'dtmf',
  //   title: 'DTMF',
  //   parameter: true,
  //   notVisibleFor: ['Polycom'],
  // },
  // {
  //   value: 'yealink',
  //   title: 'Yealink',
  //   parameter: true,
  //   notVisibleFor: ['Polycom'],
  // },
];
